import {IHttpService} from "angular";
import {AlertLevel, SystemAlerts} from "../model/SystemAlert";
import {CurrentUserService} from "../../../../services/user/CurrentUserService";
import {Branding} from "app/types/Branding";
import {CurrentUser} from "../../../../services/user/models/CurrentUser";
import moment from "moment";
import {MARKET_ZONE, marketTime} from "../../../../js/util/DateTimeUtil";

export class SystemAlertsService {

    public static readonly id = "systemAlertService";

    /** @ngInject */
    public constructor(private readonly $http: IHttpService,
                       private readonly currentUserService: CurrentUserService) {

    }

    public async current(): Promise<SystemAlerts> {
        /*
        const url = `/tradefloor/api/system-alerts/current`;
        const response = await this.$http.get<SystemAlerts>(url);
        return response.data;
         */
        // return [
        //
        // ];

        return this.currentUserService
                   .current
                   .first()
                   .map(omtAlert)
                   .toPromise();

    }
}

function omtAlert(currentUser: CurrentUser): SystemAlerts {
    const isOt = currentUser.branding() === Branding.OPEN_TRADER;
    const otEnd = moment.tz("2021-08-20T00:00:00", MARKET_ZONE);
    const now = marketTime();

    if (isOt && now.isBefore(otEnd)) {
        const message = "Please note: some Macquarie bank cash balances may be displaying incorrectly. We're fixing this as soon as we can.";
        return [
            {
                level: AlertLevel.CRITICAL,
                messages: {
                    English: message,
                    Chinese: message
                },
                url: null
            }
        ];
    } else {
        return [];
    }
}
